import React from 'react';
import { NavConfig } from '../../../../models/configs/navConfig';
import s from './WebsiteMap.scss';
import { LinkWrapper } from '../../../../components/BaseComp';

interface Props {
    data: NavConfig[],
    spm: string,
}

export const WebsiteMapBlock = (props: Props) => {
    const { data, spm } = props;
    return (
        <div className={s.block} data-spm={`map-${spm}`}>
            {
                data.map((nav, index) =>
                    <LinkWrapper className={index === 0 ? s.fullLink : s.link} key={index + nav.name} href={nav.link}>{nav.name}</LinkWrapper>,
                )
            }
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/pages/HomePageV2/components/WebsiteMap/WebsiteBlock.tsx